module.exports = __webpack_public_path__ + "static/media/detalhes.03eaf8ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/detalhes.svg
// module id = 2889
// module chunks = 0